module.exports = __webpack_public_path__ + "static/media/BF.ef36901d.gif";